module.exports = __webpack_public_path__ + "img/32-windows.fe6ccfc1.png";